import { combineReducers } from 'redux'

import authedUser from './authedUser'
import users from './users'
import token from './token'

export default combineReducers({
    authedUser, users, token
})
